module.exports = __webpack_public_path__ + "static/1-d7c5e4b8e2b6a3bae1d8392ed8cb47d2.jpeg";